import * as React from 'react';
import { EngineConfigProvider } from './EngineConfigProvider';
export const EngineProvider = ({ children, ...config })=>{
    const stableConfig = React.useMemo(()=>{
        var _config_cssPolicy, _config_useInsertion;
        return {
            cssPolicy: (_config_cssPolicy = config.cssPolicy) !== null && _config_cssPolicy !== void 0 ? _config_cssPolicy : 'runtime-only',
            useInsertion: (_config_useInsertion = config.useInsertion) !== null && _config_useInsertion !== void 0 ? _config_useInsertion : false
        };
    }, [
        config.cssPolicy,
        config.useInsertion
    ]);
    return /*#__PURE__*/ React.createElement(EngineConfigProvider, {
        config: stableConfig
    }, children);
};

//# sourceMappingURL=EngineProvider.js.map